export default __webpack_public_path__ + "static/media/02d.52bd8da9.svg";